/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateDocumentDto } from '../../models/create-document-dto';
import { DocumentDto } from '../../models/document-dto';

export interface AdminDocumentControllerUpdateDocument$Params {
  id: string;
      body: CreateDocumentDto
}

export function adminDocumentControllerUpdateDocument(http: HttpClient, rootUrl: string, params: AdminDocumentControllerUpdateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDto>> {
  const rb = new RequestBuilder(rootUrl, adminDocumentControllerUpdateDocument.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentDto>;
    })
  );
}

adminDocumentControllerUpdateDocument.PATH = '/api/document-admin/{id}';
